/**
 * Data Management
 * Phase 2.2: Integrated backup/restore and audit trail interface
 * Professional data management with export/import and compliance logging
 */
import React, { useState } from 'react';
import BackupManager from './backup/BackupManager';
import AuditTrailPage from './audit/AuditTrailPage';
import { 
  Download,
  FileText,
  ArrowLeft
} from 'lucide-react';

const VIEWS = {
  BACKUP: 'backup',
  AUDIT: 'audit'
};

export const DataManagement = ({ onBack }) => {
  const [currentView, setCurrentView] = useState(VIEWS.BACKUP);

  const renderCurrentView = () => {
    switch (currentView) {
      case VIEWS.BACKUP:
        return <BackupManager />;
      case VIEWS.AUDIT:
        return <AuditTrailPage />;
      default:
        return <BackupManager />;
    }
  };

  const getActiveTabClass = (view) => {
    return currentView === view
      ? 'border-cyan-500 text-cyan-600'
      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-4">
              {onBack && (
                <button
                  onClick={onBack}
                  className="p-2 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100"
                >
                  <ArrowLeft className="h-5 w-5" />
                </button>
              )}
              <h1 className="text-xl font-semibold text-gray-900">
                Data Management
              </h1>
            </div>
          </div>
          
          {/* Navigation Tabs */}
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8">
              <button
                onClick={() => setCurrentView(VIEWS.BACKUP)}
                className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${getActiveTabClass(VIEWS.BACKUP)}`}
              >
                <Download className="h-5 w-5 mr-2 inline" />
                Backup & Restore
              </button>
              
              <button
                onClick={() => setCurrentView(VIEWS.AUDIT)}
                className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${getActiveTabClass(VIEWS.AUDIT)}`}
              >
                <FileText className="h-5 w-5 mr-2 inline" />
                Audit Trail
              </button>
            </nav>
          </div>
        </div>
      </div>

      {/* Content */}
      <main className="py-8">
        {renderCurrentView()}
      </main>
    </div>
  );
};

export default DataManagement;